import React from 'react';
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import FacebookLogin from 'react-facebook-login';
import './style.css';
import { useState } from 'react';
import {login} from "../redux/reducers/user-actions";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

function LoginPage(){
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [emailError, setEmailError] = useState('');
    const [loginError, setLoginError] = useState(null);
    const [resendStatus, setResendStatus] = useState(null);
    const [verifyCode, setVerifyCode] = useState('');
    const [verifyStatus, setVerifyStatus] = useState(null);
    const [verifyError, setVerifyError] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const validateEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
    const handleGoogleLoginSuccess = (response) => {
        console.log('Google login success:', response);
        // Handle login success (e.g., send token to your server)
      };
    
      const handleGoogleLoginFailure = (response) => {
        console.log('Google login failure:', response);
        // Handle login failure
      };
    
      const handleFacebookLogin = (response) => {
        console.log('Facebook login success:', response);
        // Handle login success (e.g., send token to your server)
      };
    const handleResendVerify = async () => {
        setResendStatus('sending');
        try {
            const response = await fetch(process.env.REACT_APP_API_URL + '/api/resendverifyemail', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ user_id: loginError.userId }),
            });
            setResendStatus(response.ok ? 'sent' : 'error');
        } catch {
            setResendStatus('error');
        }
    };
    const handleVerifyCode = async () => {
        if (verifyCode.trim() === '') return;
        setVerifyStatus('verifying');
        setVerifyError('');
        try {
            const response = await fetch(process.env.REACT_APP_API_URL + '/api/verifyemail?token=' + encodeURIComponent(verifyCode.trim()));
            if (!response.ok) {
                setVerifyError('驗證碼錯誤或已過期，請再試一次或重新寄送驗證信。');
                setVerifyStatus(null);
                return;
            }
            setVerifyStatus('verified');
        } catch {
            setVerifyError('驗證失敗，請稍後再試。');
            setVerifyStatus(null);
        }
    };
    const handleRegist = (e) => {
        e.preventDefault();
        console.log('Register button clicked');
        navigate('/registration');
    }
    const handleLogin = async(e) => {
        e.preventDefault();
        setLoading(true);
        setLoginError(null);
        const user = { email:email, password:password };
        try {
            const response = await fetch(process.env.REACT_APP_API_URL + '/api/login', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(user),
            });
            if (response.status === 403) {
              const data = await response.json();
              setLoginError({ type: 'unverified', userId: data.user_id });
              setLoading(false);
              return;
            }
            if (!response.ok) {
              setLoginError({ type: 'invalid' });
              setLoading(false);
              return;
            }
            const data = await response.json();
            dispatch(login(data.user, data.token));
            navigate('/');
          } catch (error) {
            console.error('There was a problem with the login request:', error);
            setLoginError({ type: 'invalid' });
            setLoading(false);
          }
    }
    return (
        <GoogleOAuthProvider clientId="YOUR_GOOGLE_CLIENT_ID">
      <Container className="" style={{ marginBottom: '150px' }}>
        <Row className="justify-content-md-center">
          <Col md="4">
            <h2 className="text-center mt-4">Login</h2>
            <Form className="mb-5">
              <Form.Group controlId="formBasicEmail">
                <Form.Label className="form-label-lg">電子郵件帳號</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  className="mb-2"
                  onChange={(e) => { setEmail(e.target.value); setEmailError(''); }}
                  onBlur={() => { if (email && !validateEmail(email)) setEmailError('請輸入有效的電子郵件地址'); }}
                  isInvalid={!!emailError}
                />
                <Form.Control.Feedback type="invalid">{emailError}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId="formBasicPassword">
                <Form.Label className="form-label-lg">密碼</Form.Label>
                <Form.Control type="password" placeholder="Password" className="mb-2" onChange={(e) => setPassword(e.target.value)}/>
                <a
                  style={{fontSize: '18px'}}
                  href="/forgetpassword"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/forgetpassword' + (email ? '?email=' + encodeURIComponent(email) : ''));
                  }}
                >忘記密碼</a>
              </Form.Group>
              <div className="text-center mt-3 mb-5">
              {/* <GoogleLogin
                onSuccess={handleGoogleLoginSuccess}
                onFailure={handleGoogleLoginFailure}
                buttonText="Login with Google"
                style={{ width: '100%', marginBottom: '10px' }}
              />
              <FacebookLogin
                appId="YOUR_FACEBOOK_APP_ID"
                autoLoad={false}
                fields="name,email,picture"
                callback={handleFacebookLogin}
                textButton="Login with Facebook"
                cssClass="btnFacebook"
                icon="fa-facebook"
              /> */}
            </div>
            {loginError?.type === 'unverified' && (
              <Alert variant="warning" className="mt-3">
                <Alert.Heading style={{ fontSize: '1rem', fontWeight: 'bold' }}>電子郵件尚未驗證</Alert.Heading>
                {verifyStatus === 'verified' ? (
                  <p className="mb-0 text-success" style={{ fontSize: '0.9rem' }}>
                    ✓ 電子郵件已驗證成功！請重新輸入密碼登入。
                  </p>
                ) : (
                  <>
                    <p className="mb-1">您的帳號尚未完成電子郵件驗證，無法登入。</p>
                    <p className="mb-2" style={{ fontSize: '0.9rem' }}>
                      請至信箱（包含垃圾郵件資料夾）查收驗證信，並於下方輸入信中的驗證碼：
                    </p>
                    <Form.Group controlId="formVerifyCode" className="mb-2">
                      <Form.Control
                        type="text"
                        size="sm"
                        placeholder="請輸入信件中的驗證碼"
                        value={verifyCode}
                        onChange={(e) => { setVerifyCode(e.target.value); setVerifyError(''); }}
                        isInvalid={!!verifyError}
                      />
                      <Form.Control.Feedback type="invalid">{verifyError}</Form.Control.Feedback>
                    </Form.Group>
                    <Button
                      size="sm"
                      variant="dark"
                      className="mb-2"
                      onClick={handleVerifyCode}
                      disabled={verifyCode.trim() === '' || verifyStatus === 'verifying'}
                    >
                      {verifyStatus === 'verifying' ? '驗證中...' : '驗證'}
                    </Button>
                    <hr className="my-2" />
                    <p className="mb-1" style={{ fontSize: '0.85rem' }}>沒收到驗證信？</p>
                    {resendStatus === 'sent'
                      ? <p className="mb-0 text-success" style={{ fontSize: '0.9rem' }}>✓ 驗證信已重新寄出，請查收信箱（包含垃圾郵件資料夾）。</p>
                      : resendStatus === 'error'
                      ? <p className="mb-0 text-danger" style={{ fontSize: '0.9rem' }}>寄送失敗，請稍後再試。</p>
                      : <Button size="sm" variant="outline-dark" onClick={handleResendVerify} disabled={resendStatus === 'sending'}>
                          {resendStatus === 'sending' ? '寄送中...' : '重新寄送驗證信'}
                        </Button>
                    }
                  </>
                )}
              </Alert>
            )}
            {loginError?.type === 'invalid' && (
              <Alert variant="danger" className="mt-3">
                電子郵件或密碼錯誤，請再試一次。
              </Alert>
            )}
            <div className="mb-4">
              <Row className="justify-content-end">
                <Col xs="auto">
                  <Button variant="dark" type="submit" block onClick={handleLogin} disabled={loading}>
                    {loading ? '登入中...' : '登入'}
                  </Button>
                </Col>
                <Col xs="auto">
                  <Button variant="dark" type="regist" block onClick={handleRegist}>
                    註冊
                  </Button>
                </Col>
              </Row>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </GoogleOAuthProvider>
    );
};

export default LoginPage;